const DEFAULT_WORDS_PER_MINUTE = 200;
const PLACEHOLDER_MINUTES = 5;

/**
 * Displays estimated reading time from a server-provided word count.
 */
class BlogPostReadingTime extends HTMLElement {
  connectedCallback() {
    this.#render();
  }

  #render() {
    const output = this.querySelector('[data-reading-time-value]');
    if (!output) return;

    const wordCount = Number.parseInt(this.dataset.wordCount || '0', 10);
    const wpm = Number.parseInt(this.dataset.wordsPerMinute || '', 10) || DEFAULT_WORDS_PER_MINUTE;
    const minutesLabel = this.dataset.minutesLabel || 'min';

    const minutes =
      wordCount > 0 ? Math.max(1, Math.ceil(wordCount / wpm)) : PLACEHOLDER_MINUTES;

    output.textContent = `${minutes} ${minutesLabel}`;
  }
}

if (!customElements.get('blog-post-reading-time')) {
  customElements.define('blog-post-reading-time', BlogPostReadingTime);
}
